import badgeGold from "@assets/images/icons/badge-gold.svg";
import badgeSilver from "@assets/images/icons/badge-silver.svg";
import badgeBronze from "@assets/images/icons/badge-bronze.svg";
import btcIcon from "@assets/images/futures_pairs/btcusdt.svg";
import solIcon from "@assets/images/futures_pairs/solusdt.svg";
import trxIcon from "@assets/images/futures_pairs/trxusdt.svg";

export const BADGE_ICONS = {
  "badge-gold": badgeGold,
  "badge-silver": badgeSilver,
  "badge-bronze": badgeBronze,
};

export const COIN_ICONS = {
  "btc-orange": btcIcon,
  "sol-purple": solIcon,
  "trx-red": trxIcon,
  BTC: btcIcon,
  SOL: solIcon,
  TRX: trxIcon,
};

/** Relative ISO timestamp so range filters stay valid over time */
const daysAgoIso = (days, hours = 0) =>
  new Date(Date.now() - (days * 24 + hours) * 60 * 60 * 1000).toISOString();

const lb = ({
  rank,
  badgeIcon = null,
  user,
  favoriteIcon = "star-gray",
  trades,
  favoriteAsset,
  totalWagered,
  totalRoi,
  biggestWin,
  totalProfit,
  daysAgo = 0,
  hoursAgo = 0,
}) => {
  const updatedAt = daysAgoIso(daysAgo, hoursAgo);
  return {
    rank,
    badgeIcon,
    user,
    favoriteIcon,
    trades,
    favoriteAsset,
    totalWagered,
    totalRoi,
    biggestWin,
    totalProfit,
    updatedAt,
  };
};

// Mock trade details shown in the trade details modal. Prices and P&L aren't
// here: communityService takes them from the market at the trade times
const PUBLIC_FEED_FIRST_TRADE_ID = 783429;
const BEST_TRADES_FIRST_TRADE_ID = 790100;
const HOLD_SECONDS = [11, 252, 2280, 3900, 12000, 93600];
const MS_PER_SECOND = 1000;
const MS_PER_MINUTE = 60 * MS_PER_SECOND;

/** Open and close moments of a mock trade, closedAt is null while it's open */
const tradeTimes = (openedAt, closedAt = null) => ({
  openedAt,
  closedAt,
  // UTC ISO 8601, as created_at of our orders API
  created_at: new Date(openedAt).toISOString(),
});

const closedTradeTimes = (closedIso, holdSeconds) => {
  const closedAt = new Date(closedIso).getTime();

  return tradeTimes(closedAt - holdSeconds * MS_PER_SECOND, closedAt);
};

const withTradeInfo = (items) =>
  items.map((item, index) => ({
    tradeId: String(PUBLIC_FEED_FIRST_TRADE_ID + index),
    ...closedTradeTimes(
      daysAgoIso(0, index + 1),
      HOLD_SECONDS[index % HOLD_SECONDS.length],
    ),
    ...item,
  }));

const bt = ({
  rank,
  badgeIcon = null,
  user,
  favoriteIcon = "star-gray",
  trade,
  wager,
  leverage,
  daysAgo = 0,
  hoursAgo = 0,
}) => {
  const updatedAt = daysAgoIso(daysAgo, hoursAgo);
  return {
    rank,
    badgeIcon,
    user,
    favoriteIcon,
    updatedAt,
    ...closedTradeTimes(updatedAt, HOLD_SECONDS[rank % HOLD_SECONDS.length]),
    trade,
    // Best trades: the direction is the one that won on the market
    isWinner: true,
    tradeId: String(BEST_TRADES_FIRST_TRADE_ID + rank),
    wager,
    leverage,
  };
};

export const MOCK_COMMUNITY_DATA = {
  publicFeed: withTradeInfo([
    {
      id: 1,
      username: "C1ltra",
      favoriteIcon: "star-yellow",
      trade: {
        direction: "up",
        coin: "SOL",
        coinIcon: "sol-purple",
      },
      wager: "$2,101.77",
      leverage: "100x",
    },
    {
      id: 2,
      username: "Joicj38i",
      favoriteIcon: "star-gray",
      trade: {
        direction: "down",
        coin: "BTC",
        coinIcon: "btc-orange",
      },
      wager: "$2,101.77",
      leverage: "100x",
    },
    {
      id: 3,
      username: "Anonim",
      favoriteIcon: "star-gray",
      trade: {
        direction: "up",
        coin: "TRX",
        coinIcon: "trx-red",
      },
      wager: "$2,101.77",
      leverage: "100x",
    },
    {
      id: 4,
      username: "Pandls3",
      favoriteIcon: "star-yellow",
      trade: {
        direction: "up",
        coin: "BTC",
        coinIcon: "btc-orange",
      },
      wager: "$10.77",
      leverage: "10x",
    },
    {
      id: 5,
      username: "Pandls3",
      favoriteIcon: "star-yellow",
      trade: {
        direction: "up",
        coin: "BTC",
        coinIcon: "btc-orange",
      },
      wager: "$10.77",
      leverage: "10x",
    },
  ]),

  // Mix of 1D / 1W / 1M / older so range chips filter meaningfully
  leaderboard: [
    lb({
      rank: 1,
      badgeIcon: "badge-gold",
      user: "Degen",
      favoriteIcon: "star-yellow",
      trades: "7 trades",
      favoriteAsset: { symbol: "BTC", assetIcon: "btc-orange" },
      totalWagered: "$343,864.2038",
      totalRoi: "16.20%",
      biggestWin: "+$3,205.34",
      totalProfit: "+$5,435.34",
      daysAgo: 0,
      hoursAgo: 2,
    }),
    lb({
      rank: 2,
      badgeIcon: "badge-silver",
      user: "Crypto",
      favoriteIcon: "star-gray",
      trades: "16 trades",
      favoriteAsset: { symbol: "SOL", assetIcon: "sol-purple" },
      totalWagered: "$265,864.2038",
      totalRoi: "12.45%",
      biggestWin: "+$1,764.20",
      totalProfit: "+$1,564.20",
      daysAgo: 0,
      hoursAgo: 8,
    }),
    lb({
      rank: 3,
      badgeIcon: "badge-bronze",
      user: "Anonim",
      favoriteIcon: "star-yellow",
      trades: "1 trade",
      favoriteAsset: { symbol: "TRX", assetIcon: "trx-red" },
      totalWagered: "$13,864.2038",
      totalRoi: "8.10%",
      biggestWin: "+$854.20",
      totalProfit: "+$754.20",
      daysAgo: 1,
      hoursAgo: 4,
    }),
    lb({
      rank: 4,
      user: "Locjo",
      trades: "7 trades",
      favoriteAsset: { symbol: "BTC", assetIcon: "btc-orange" },
      totalWagered: "$3,864.2038",
      totalRoi: "3.40%",
      biggestWin: "+$613.20",
      totalProfit: "+$213.20",
      daysAgo: 2,
    }),
    lb({
      rank: 5,
      user: "C1ltra",
      favoriteIcon: "star-yellow",
      trades: "12 trades",
      favoriteAsset: { symbol: "SOL", assetIcon: "sol-purple" },
      totalWagered: "$48,210.50",
      totalRoi: "9.80%",
      biggestWin: "+$1,120.00",
      totalProfit: "+$980.40",
      daysAgo: 3,
    }),
    lb({
      rank: 6,
      user: "Whale92",
      trades: "4 trades",
      favoriteAsset: { symbol: "BTC", assetIcon: "btc-orange" },
      totalWagered: "$92,400.00",
      totalRoi: "6.20%",
      biggestWin: "+$2,100.00",
      totalProfit: "+$1,840.00",
      daysAgo: 5,
    }),
    lb({
      rank: 7,
      user: "MoonBoy",
      favoriteIcon: "star-yellow",
      trades: "22 trades",
      favoriteAsset: { symbol: "TRX", assetIcon: "trx-red" },
      totalWagered: "$21,050.12",
      totalRoi: "4.55%",
      biggestWin: "+$420.10",
      totalProfit: "+$310.55",
      daysAgo: 6,
    }),
    lb({
      rank: 8,
      user: "AlphaKing",
      trades: "9 trades",
      favoriteAsset: { symbol: "BTC", assetIcon: "btc-orange" },
      totalWagered: "$15,600.00",
      totalRoi: "11.10%",
      biggestWin: "+$980.00",
      totalProfit: "+$760.00",
      daysAgo: 10,
    }),
    lb({
      rank: 9,
      user: "Pandls3",
      favoriteIcon: "star-yellow",
      trades: "3 trades",
      favoriteAsset: { symbol: "SOL", assetIcon: "sol-purple" },
      totalWagered: "$8,120.40",
      totalRoi: "2.90%",
      biggestWin: "+$190.00",
      totalProfit: "+$140.20",
      daysAgo: 14,
    }),
    lb({
      rank: 10,
      user: "Joicj38i",
      trades: "18 trades",
      favoriteAsset: { symbol: "BTC", assetIcon: "btc-orange" },
      totalWagered: "$54,300.00",
      totalRoi: "7.35%",
      biggestWin: "+$1,050.00",
      totalProfit: "+$890.00",
      daysAgo: 20,
    }),
    lb({
      rank: 11,
      user: "NightOwl",
      favoriteIcon: "star-yellow",
      trades: "5 trades",
      favoriteAsset: { symbol: "TRX", assetIcon: "trx-red" },
      totalWagered: "$6,440.00",
      totalRoi: "1.80%",
      biggestWin: "+$95.00",
      totalProfit: "+$72.40",
      daysAgo: 28,
    }),
    lb({
      rank: 12,
      user: "Stacker",
      trades: "11 trades",
      favoriteAsset: { symbol: "SOL", assetIcon: "sol-purple" },
      totalWagered: "$33,900.00",
      totalRoi: "5.10%",
      biggestWin: "+$540.00",
      totalProfit: "+$410.00",
      daysAgo: 45,
    }),
    lb({
      rank: 13,
      user: "VegaX",
      favoriteIcon: "star-yellow",
      trades: "2 trades",
      favoriteAsset: { symbol: "BTC", assetIcon: "btc-orange" },
      totalWagered: "$1,200.00",
      totalRoi: "0.90%",
      biggestWin: "+$40.00",
      totalProfit: "+$22.00",
      daysAgo: 60,
    }),
    lb({
      rank: 14,
      user: "Lot88",
      trades: "30 trades",
      favoriteAsset: { symbol: "TRX", assetIcon: "trx-red" },
      totalWagered: "$77,010.00",
      totalRoi: "13.00%",
      biggestWin: "+$2,450.00",
      totalProfit: "+$3,100.00",
      daysAgo: 90,
    }),
  ],

  bestTrades: [
    bt({
      rank: 1,
      badgeIcon: "badge-gold",
      user: "Degen",
      favoriteIcon: "star-yellow",
      trade: { symbol: "BTC", assetIcon: "btc-orange" },
      wager: "$6,101.77",
      leverage: "25x",
      daysAgo: 0,
      hoursAgo: 1,
    }),
    bt({
      rank: 2,
      badgeIcon: "badge-silver",
      user: "Crypto",
      trade: { symbol: "SOL", assetIcon: "sol-purple" },
      wager: "$564.20",
      leverage: "1000x",
      daysAgo: 0,
      hoursAgo: 6,
    }),
    bt({
      rank: 3,
      badgeIcon: "badge-bronze",
      user: "Anonim",
      favoriteIcon: "star-yellow",
      trade: { symbol: "TRX", assetIcon: "trx-red" },
      wager: "$264.20",
      leverage: "1000x",
      daysAgo: 1,
      hoursAgo: 3,
    }),
    bt({
      rank: 4,
      user: "Locjo",
      trade: { symbol: "BTC", assetIcon: "btc-orange" },
      wager: "$1,564.20",
      leverage: "100x",
      daysAgo: 2,
    }),
    bt({
      rank: 5,
      user: "C1ltra",
      favoriteIcon: "star-yellow",
      trade: { symbol: "SOL", assetIcon: "sol-purple" },
      wager: "$890.00",
      leverage: "50x",
      daysAgo: 3,
    }),
    bt({
      rank: 6,
      user: "Whale92",
      trade: { symbol: "BTC", assetIcon: "btc-orange" },
      wager: "$12,000.00",
      leverage: "20x",
      daysAgo: 4,
    }),
    bt({
      rank: 7,
      user: "MoonBoy",
      favoriteIcon: "star-yellow",
      trade: { symbol: "TRX", assetIcon: "trx-red" },
      wager: "$320.00",
      leverage: "200x",
      daysAgo: 6,
    }),
    bt({
      rank: 8,
      user: "AlphaKing",
      trade: { symbol: "BTC", assetIcon: "btc-orange" },
      wager: "$2,400.00",
      leverage: "40x",
      daysAgo: 9,
    }),
    bt({
      rank: 9,
      user: "Pandls3",
      favoriteIcon: "star-yellow",
      trade: { symbol: "SOL", assetIcon: "sol-purple" },
      wager: "$150.00",
      leverage: "75x",
      daysAgo: 12,
    }),
    bt({
      rank: 10,
      user: "Joicj38i",
      trade: { symbol: "BTC", assetIcon: "btc-orange" },
      wager: "$3,200.00",
      leverage: "30x",
      daysAgo: 18,
    }),
    bt({
      rank: 11,
      user: "NightOwl",
      favoriteIcon: "star-yellow",
      trade: { symbol: "TRX", assetIcon: "trx-red" },
      wager: "$95.00",
      leverage: "100x",
      daysAgo: 25,
    }),
    bt({
      rank: 12,
      user: "Stacker",
      trade: { symbol: "SOL", assetIcon: "sol-purple" },
      wager: "$1,100.00",
      leverage: "60x",
      daysAgo: 40,
    }),
    bt({
      rank: 13,
      user: "VegaX",
      favoriteIcon: "star-yellow",
      trade: { symbol: "BTC", assetIcon: "btc-orange" },
      wager: "$80.00",
      leverage: "10x",
      daysAgo: 55,
    }),
    bt({
      rank: 14,
      user: "Lot88",
      trade: { symbol: "TRX", assetIcon: "trx-red" },
      wager: "$5,500.00",
      leverage: "80x",
      daysAgo: 80,
    }),
  ],
};

// Achievements a trader can unlock, the icon is one of BADGE_ICONS
export const ACHIEVEMENTS = {
  "buckle-up": { title: "Buckle Up", badgeIcon: "badge-bronze" },
  "dark-side": { title: "Dark Side Of The Moon", badgeIcon: "badge-silver" },
  "made-1k": { title: "Made $1K in 24 hours", badgeIcon: "badge-gold" },
  "never-give-up": { title: "Never Give Up", badgeIcon: "badge-bronze" },
  "high-roller": { title: "High Roller", badgeIcon: "badge-gold" },
  "diamond-hands": { title: "Diamond Hands", badgeIcon: "badge-silver" },
};

const formatShortDate = (iso) =>
  new Date(iso).toLocaleDateString("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "2-digit",
  });

// Open trade of a trader, shown in the Trades tab of the profile
const openTrade = ({
  coin,
  direction = "up",
  wager,
  leverage,
  minutesAgo,
  tradeId,
}) => ({
  tradeId,
  trade: {
    direction,
    coin,
    coinIcon: { BTC: "btc-orange", SOL: "sol-purple", TRX: "trx-red" }[coin],
  },
  wager,
  leverage,
  isOpen: true,
  ...tradeTimes(Date.now() - minutesAgo * MS_PER_MINUTE),
});

const profile = ({
  avatar = null,
  followers,
  winRate,
  biggestMultiplier,
  memberDaysAgo,
  achievements = [],
  openTrades = [],
}) => ({
  // Comes as a URL from the API, null when the trader has no photo
  avatar,
  followers,
  winRate,
  biggestMultiplier,
  memberSince: new Date(daysAgoIso(memberDaysAgo)).toLocaleDateString(
    "en-US",
    { month: "long", day: "numeric", year: "numeric" },
  ),
  // [achievement id, days ago it was unlocked]
  achievements: achievements.map(([id, daysAgo]) => ({
    id,
    ...ACHIEVEMENTS[id],
    date: formatShortDate(daysAgoIso(daysAgo)),
  })),
  openTrades,
});

// Profile data the leaderboard rows don't have, by username
export const TRADER_PROFILES = {
  Degen: profile({
    avatar: "https://i.pravatar.cc/128?img=12",
    followers: 1342,
    winRate: "58.38%",
    biggestMultiplier: "5.54x",
    memberDaysAgo: 420,
    achievements: [["buckle-up", 4], ["dark-side", 4], ["made-1k", 3], ["never-give-up", 2], ["high-roller", 1]],
    openTrades: [
      openTrade({ tradeId: "801201", coin: "BTC", wager: "$400.00", leverage: "100x", minutesAgo: 25 }),
      openTrade({ tradeId: "801202", coin: "SOL", direction: "down", wager: "$400.00", leverage: "100x", minutesAgo: 95 }),
      openTrade({ tradeId: "801203", coin: "TRX", wager: "$120.00", leverage: "50x", minutesAgo: 190 }),
      openTrade({ tradeId: "801204", coin: "BTC", direction: "down", wager: "$400.00", leverage: "100x", minutesAgo: 25 }),
    ],
  }),
  Crypto: profile({
    followers: 864,
    winRate: "52.10%",
    biggestMultiplier: "3.12x",
    memberDaysAgo: 310,
    achievements: [["buckle-up", 30], ["high-roller", 12]],
    openTrades: [
      openTrade({ tradeId: "801301", coin: "SOL", wager: "$1,000.00", leverage: "20x", minutesAgo: 340 }),
    ],
  }),
  Anonim: profile({ followers: 12, winRate: "100.00%", biggestMultiplier: "1.99x", memberDaysAgo: 40, achievements: [["buckle-up", 39]] }),
  Locjo: profile({
    avatar: "https://i.pravatar.cc/128?img=5",
    followers: 57,
    winRate: "42.86%",
    biggestMultiplier: "2.40x",
    memberDaysAgo: 95,
    achievements: [["buckle-up", 90], ["diamond-hands", 20]],
    openTrades: [
      openTrade({ tradeId: "801401", coin: "BTC", direction: "down", wager: "$50.00", leverage: "10x", minutesAgo: 12 }),
    ],
  }),
  C1ltra: profile({
    avatar: "https://i.pravatar.cc/128?img=33",
    followers: 230,
    winRate: "66.67%",
    biggestMultiplier: "4.05x",
    memberDaysAgo: 210,
    achievements: [["buckle-up", 200], ["never-give-up", 60], ["diamond-hands", 15]],
    openTrades: [
      openTrade({ tradeId: "801501", coin: "SOL", wager: "$2,101.77", leverage: "100x", minutesAgo: 75 }),
      openTrade({ tradeId: "801502", coin: "BTC", wager: "$10.77", leverage: "10x", minutesAgo: 8 }),
    ],
  }),
  Whale92: profile({ followers: 2051, winRate: "75.00%", biggestMultiplier: "2.20x", memberDaysAgo: 600, achievements: [["buckle-up", 590], ["high-roller", 400], ["diamond-hands", 100]] }),
  MoonBoy: profile({ avatar: "https://i.pravatar.cc/128?img=59", followers: 98, winRate: "45.45%", biggestMultiplier: "6.10x", memberDaysAgo: 150, achievements: [["buckle-up", 149], ["dark-side", 70]] }),
  AlphaKing: profile({ followers: 411, winRate: "55.56%", biggestMultiplier: "3.80x", memberDaysAgo: 275, achievements: [["buckle-up", 270], ["made-1k", 33]] }),
  Pandls3: profile({ followers: 35, winRate: "38.46%", biggestMultiplier: "1.75x", memberDaysAgo: 60, achievements: [["buckle-up", 58]] }),
  Joicj38i: profile({ followers: 19, winRate: "40.00%", biggestMultiplier: "1.40x", memberDaysAgo: 30, achievements: [["buckle-up", 29]] }),
  NightOwl: profile({ avatar: "https://i.pravatar.cc/128?img=47", followers: 740, winRate: "61.90%", biggestMultiplier: "4.70x", memberDaysAgo: 380, achievements: [["buckle-up", 370], ["never-give-up", 120], ["dark-side", 44], ["made-1k", 9]] }),
  Stacker: profile({ followers: 88, winRate: "50.00%", biggestMultiplier: "2.05x", memberDaysAgo: 120, achievements: [["buckle-up", 118], ["high-roller", 50]] }),
  VegaX: profile({ followers: 143, winRate: "47.37%", biggestMultiplier: "2.90x", memberDaysAgo: 200, achievements: [["buckle-up", 199], ["diamond-hands", 80]] }),
  Lot88: profile({ followers: 6, winRate: "33.33%", biggestMultiplier: "1.20x", memberDaysAgo: 14 }),
};
